"use strict";require("react"),require("react-helmet");var e=require("react/jsx-runtime");exports.default=()=>e.jsx(e.Fragment,{});